import {
  SubTenantUsersGridData,
  SubTenantUsersGridRequest,
} from "components/pages/maintanance/subTenantUserManagement/SubTenantUserManagementList/SubTenantUserManagementList.models"
import { getSubTenantUsersGridData } from "queries"
import { ebateQueryKeys, useEbateInfinityQuery } from "queries/ebateReactQuery"
import {
  CacheTime,
  StaleTime,
} from "queries/ebateReactQuery/ebateReactQuery.models"
import { useContext, useEffect, useState } from "react"
import { AuthenticationContext } from "stores"

export const useSubTenantUserGridData = (
  subTenantUserFilter: SubTenantUsersGridRequest
) => {
  const { getTokenValue } = useContext(AuthenticationContext)
  const [authCompanyOwnerId] = useState(
    parseInt(getTokenValue("subtenantCompanyId"), 10)
  )
  const getUniqueValues = (data): SubTenantUsersGridData[] => {
    const flattened = data.pages.flatMap((page) => page.userGridItems)
    const arrayUniqueByKey = [
      ...new Map(flattened.map((item) => [item.id, item])).values(),
    ] as SubTenantUsersGridData[]
    return arrayUniqueByKey
  }

  const fetchData = async () => {
    const response = await getSubTenantUsersGridData(
      subTenantUserFilter.request,
      authCompanyOwnerId && authCompanyOwnerId > 0
        ? authCompanyOwnerId
        : subTenantUserFilter.subtenantCompanyId
    )
    if (response?.status === 200) {
      return response.data
    }
    throw new Error("Failed to fetch data")
  }

  const { data, fetchNextPage, isLoading, isError } = useEbateInfinityQuery(
    [
      ...ebateQueryKeys.QUERY_KEY_SUBTENANT_USER_GRID_DATA,
      subTenantUserFilter.request.orderBy,
      subTenantUserFilter.request.isAscending ? "true" : "false",
      authCompanyOwnerId && authCompanyOwnerId > 0
        ? authCompanyOwnerId.toString()
        : subTenantUserFilter?.subtenantCompanyId?.toString() || "",
      subTenantUserFilter.request.search,
    ],
    fetchData,
    {
      staleTime: StaleTime.infinity,
      cacheTime: CacheTime.zero,
      getNextPageParam: (lastPage, allPages) =>
        lastPage.numberOfPages >= subTenantUserFilter.request.currentPage
          ? subTenantUserFilter.request.currentPage + 1
          : undefined,
    }
  )
  useEffect(() => {
    fetchNextPage()
  }, [fetchNextPage, subTenantUserFilter])

  const subTenantUsers = data ? getUniqueValues(data) : []
  const hasMore =
    data?.pages[0]?.numberOfPages > subTenantUserFilter.request.currentPage

  return { subTenantUsers, hasMore, isLoading, isError }
}
